import Vue from "vue";
import App from "./App.vue";
import boot from '@/app/booting/boot.js'
import 'izitoast/dist/css/iziToast.min.css'
import "./registerServiceWorker";
import "@/../public/css/app-css.css"

Vue.config.productionTip = false;
boot(Vue).then( (config) => {
  new Vue({...config, render: h => h(App)}).$mount('#app');
})
